import type { FunctionalComponent } from 'preact';
import { formatPrice } from '@/lib/utils.ts';
import type { DaoPoint } from '@/types/dao.ts';

/** 포인트 내역 한 줄 (마이페이지 미리보기 / 전체 내역 공용) */
export const PointItem: FunctionalComponent<{ dao: DaoPoint }> = ({ dao }) => {
  const amount = dao.point ?? 0;

  return (
    <div class="history-item">
      <div class="item-left">
        <div class="item-name">{dao.name}</div>
        {/*
          어느 미션으로 받았는지. 2026-09-11 이전 기록에는 없어서, 있을 때만 그린다.
        */}
        {dao.detail && <div class="item-detail">{dao.detail}</div>}
        <div class="item-date">{dao.registDate}</div>
      </div>
      <div class={amount < 0 ? 'item-right negative' : 'item-right positive'}>
        {amount > 0 ? '+' : ''}
        {formatPrice(amount)} P
      </div>
    </div>
  );
};

/** 내역이 없을 때 자리를 채우는 행 */
export const PointEmpty: FunctionalComponent = () => (
  <div class="history-item">
    <div class="item-left">
      <div class="item-name">포인트 내역이 없습니다.</div>
    </div>
  </div>
);
